import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useInvActivity = ({
  acctId,
  propertyId
}: {
  acctId: string;
  propertyId: string;
}) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useInfiniteQuery({
    queryKey: ["inv-activity", acctId, propertyId],
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }: any) => {
      try {
        const data: any = queryClient.getQueryData([
          "inv-activity",
          acctId,
          propertyId
        ]);
        const response = await axios.get(`${t("inv-activity")}`, {
          params: {
            acctId: acctId,
            pubPropertyId: propertyId,
            page: pageParam,
            limit: 10,
            ...(pageParam > 1 && {
              latestActivityDate: data?.pages[pageParam - 2]?.latestActivityDate
            })
          }
        });
        return response.data.data;
      } catch (error) {
        console.error("Error fetching flipper vault data:", error);
        return {
          activities: [],
          latestActivityDate: ""
        };
      }
    },
    placeholderData: (previousData) => previousData,
    getNextPageParam: (lastPage: any, allPages: any) => {
      if (!lastPage.activities || lastPage.activities.length === 0) {
        return undefined;
      }
      return allPages?.length + 1;
    }
  });
};
